"use client";

import React, { useEffect, useState, useRef } from "react";
import Link from "next/link";
import { preContent } from "@/helpers/utils";

export default function HomeNoticias({ data }) {
  const docs = data?.docs ?? [];
  return (
    <section className="w-full bg-white py-16 px-4">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col items-center text-center">
        <h2 className="text-[32px] sm:text-[36px] md:text-[40px] font-bold text-blue-700 mb-6">
          Insights e Notícias do Setor
        </h2>

        <img src="/assets/logos1.png" alt="Logos" className="w-[200px] sm:w-[250px] md:w-[300px] mb-10" />

        { docs.length > 0 ? (
          <div className="w-full max-w-[1440px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-items-center mb-12">
            {docs.map((item, key) => (
              <div
                key={key}
                className="w-[400px] h-[600px] rounded-2xl overflow-visible shadow-lg transform transition-transform duration-300 hover:-translate-y-2 relative bg-transparent mb-10"
              >
                <div className="bg-blue-700 h-[230px] rounded-t-2xl relative flex justify-center items-end">
                  <img
                    src={ item.contentImages1.mediaCdnUrl }
                    alt={ item.contentTitle }
                    className="w-[360px] h-[270px] object-cover rounded-t-xl absolute bottom-[-20px] shadow-lg"
                  />
                </div>
                <div className="bg-[#ecf0f1] h-[360px] px-6 py-8 text-left rounded-b-2xl">
                  <h3 className="text-blue-700 text-[20px] font-semibold mb-2">
                    { item.contentTitle }
                  </h3>
                  <div className="w-[60px] h-[2px] bg-blue-700 mb-3"></div>
                  <p className="text-gray-800 text-[15px] leading-snug mb-5">
                   { preContent(item.contentEditor1) }
                  </p>
                  <Link href={`/noticias/${ item.contentSlug }`} className="text-blue-700 font-semibold text-[15px] hover:underline cursor-pointer">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-500 col-span-full">
            Nenhuma notícia encontrada.
          </p>
        )}

        <div className="w-full flex justify-center">
          <Link href={`/noticias`} className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition duration-300">
            Todas as notícias
          </Link>
        </div>
      </div>
    </section>
  );
}
